// getExternalData.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

const defaultSelectPath = [];

/**
 * Select external data by data key
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {array} selectPath - select path.
 * @param {string} dataKey - data key.
 * @return {any} The selected external data.
 */
const getExternalData = createCachedSelector(
  (state, selectPath = defaultSelectPath) =>
    state.getIn(['externalData', ...selectPath]),
  (state, selectPath, dataKey) => dataKey,
  (external, dataKey) => {
    let result = undefined;
    if (external) {
      result = !dataKey ? external : external.get?.(dataKey);
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)((state, selectPath, dataKey) => `${selectPath.join(':')}:${dataKey}`);

export default getExternalData;
